import type { ZodTypeDef, ZodType } from 'zod';

export function getParsedValueOr<Output = unknown, Def extends ZodTypeDef = ZodTypeDef, Input = Output>(
  schema: ZodType<Output, Def, Input>,
  data: unknown,
  defaultValue: Output
): Output {
  const parseResult = schema.safeParse(data);
  if (parseResult.success) {
    return parseResult.data;
  } else {
    return defaultValue;
  }
}
